// @flow

import type { StoreResourceDef } from 'app/core/types'

export const personAttributeValues: StoreResourceDef<> = {
  resourceType: 'personAttributeValues',
}
